export default {
  "content": "<path d=\"M5.5 5.7c0-.11.09-.2.2-.2h12.6c.11 0 .2.09.2.2v12.6a.2.2 0 01-.2.2H5.7a.2.2 0 01-.2-.2V5.7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};